import React from 'react';

export type LetterAvatarProps = {
  backgroundColor?: string;
  textColor?: string;
  children?: string;
  className?: string;
  fontSize?: number;
  initials?: string;
};

export const extractInitials = (name?: string | null) => {
  const parts = name?.split(' ') || [];

  if (!parts[0]) {
    return '';
  }

  if (parts.length > 1) {
    return (
      parts[0].substring(0, 1) + parts[parts.length - 1]?.substring(0, 1)
    ).toUpperCase();
  }

  return parts[0].substring(0, 2).toUpperCase();
};

const BASE_SIZE = 32;

export const LetterAvatar = ({
  textColor = '#000000',
  // Sand
  backgroundColor = '#F8E6CF',
  className,
  fontSize = 12,
  initials = '',
}: LetterAvatarProps) => {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden>
      <circle
        cx={BASE_SIZE / 2}
        cy={BASE_SIZE / 2}
        r={BASE_SIZE / 2}
        fill={backgroundColor}
      />
      <text
        textAnchor="middle"
        dominantBaseline="middle"
        x={BASE_SIZE / 2}
        y={BASE_SIZE / 2 + 1}
        fill={textColor}
        style={{
          fontSize: fontSize,
          fontWeight: 500,
          userSelect: 'none',
        }}
      >
        {initials.substring(0, 2)}
      </text>
    </svg>
  );
};
